import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fetchStoryDetails } from '../../services/storyService';
import { selectUser } from '../../redux/reducers/userReducer';
import { useLoader } from '../../hooks/useLoader';
import { IColumn } from '../../types/ColumnTypes';

export const useFetchStoryDetails = () => {
  const [storyDetails, setStoryDetails] = useState<IColumn | null>(null);

  const { id } = useParams();
  const user = useSelector(selectUser);
  const { showLoading } = useLoader();

  useEffect(() => {
    const getStoryDetails = async () => {
      try {
        showLoading(true);
        const response = await fetchStoryDetails({
          email: user.data?.user.user_id || '',
          storyId: id || '',
        });
        setStoryDetails(response.data.data);
        showLoading(false);
      } catch (error) {
        showLoading(false);
      }
    };

    getStoryDetails();
  }, []);

  return { storyDetails };
};
